/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/search/ProductCard.js
 */

import config from '../config';
import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
// import { getJwt } from '../utils/store';

const CARD_NAME = 'Product Card';

const getLink = (data) => `/search?query=feature:${data}`;

const customerLink = `/search?query=`;
const customerDetailsUrl = `${getBaseUrlFromConfig(
  config.biztechApi
)}/customer/customer-accounts/`;

const notAvailableResultItem = (
  <div className="ResultItem">
    <div className="ResultLabel">Not available</div>
  </div>
);

class ProductCard extends Component {
  componentWillMount() {
    const { customerInfo } = this.props.data;
    if (!customerInfo) return;
    const customerDetailsGetCalls = customerInfo.map((info) =>
      axios.get(`${customerDetailsUrl}${info.customerId}`, {
        headers: {
          'content-type': 'application/json',
        },
      })
    );
    Promise.all(customerDetailsGetCalls)
      .then((results) => {
        const customerDetails = results.map(
          (customerDetail) => customerDetail.data.data
        );
        this.setState({ customerDetails });
      })
      .catch((ex) => {
        // console.error('ProductCard', ex);
      })
      .finally(() => this.setState({ isFetchingCustomerDetails: false }));
  }

  constructor() {
    super();
    this.state = {
      customerDetails: null,
      currentCustomerDetailIndex: null,
      isFetchingCustomerDetails: true,
    };
  }

  showCustomerDetails(index) {
    if (this.state.isFetchingCustomerDetails) {
      return;
    }
    if (this.state.currentCustomerDetailIndex === index) {
      this.setState({ currentCustomerDetailIndex: null });
    } else {
      this.setState({ currentCustomerDetailIndex: index });
    }
  }

  render() {
    const { data } = this.props;
    const {
      customerDetails,
      currentCustomerDetailIndex,
      isFetchingCustomerDetails,
    } = this.state;

    return (
      <s-container class="Card">
        <div className="SectionTitle">
          <div>
            {CARD_NAME}
            <h1>
              {data.feature.name}{' '}
              {data.tierFrom === null && data.tierTo === null
                ? null
                : `(${data.tierFrom} - ${data.tierTo})`}
            </h1>
          </div>
        </div>
        <s-container>
          <s-row>
            <s-col span="3">Feature Detail Id</s-col>
            <s-col span="4">
              {' '}
              {!data.featureDetailId ? data.id : data.featureDetailId}
            </s-col>
          </s-row>
          <s-row>
            <s-col span="3">Cpq Id</s-col>
            <s-col span="4">{data.cpqId}</s-col>
          </s-row>{' '}
          <s-row>
            <s-col span="3">Feature Id</s-col>
            <s-col span="4">
              {' '}
              <Link className="Link" to={getLink(data.feature.id)}>
                {data.feature.id}
              </Link>
            </s-col>
          </s-row>{' '}
          <s-row>
            <s-col span="3">Feature Name</s-col>
            <s-col span="7">{data.feature.name}</s-col>
          </s-row>
          {!data.featureDetailId ? (
            <s-row class="title">
              <s-col span="3">Feature Services</s-col>
            </s-row>
          ) : null}
          {!data.featureDetailId
            ? data.featureServices && data.featureServices.length > 0
              ? data.featureServices.map((featureService, index) => {
                  return (
                    <s-row key={featureService.deliverySystemSubtype}>
                      <s-col span="3">
                        {featureService.deliverySystemSubtype}
                      </s-col>
                      <s-col span="6">
                        {featureService.services.join(', ')}
                      </s-col>
                    </s-row>
                  );
                })
              : notAvailableResultItem
            : null}
          <s-row class="title">
            <s-col span="3">Sample Customers</s-col>
          </s-row>
          {data.customerInfo.length > 0
            ? data.customerInfo.map((info, index) => {
                return (
                  <div key={`${index}-${info.customerId}`}>
                    {' '}
                    <s-row
                      key={info.customerId}
                      onClick={this.showCustomerDetails.bind(this, index)}
                    >
                      <s-col span="3">
                        <Link
                          key={info.customerId}
                          className="Link"
                          to={`${customerLink}${info.customerId}`}
                        >
                          {info.customerId}
                        </Link>
                      </s-col>
                      <s-col
                        span="6"
                        style={
                          isFetchingCustomerDetails
                            ? { cursor: 'wait' }
                            : { cursor: 'pointer' }
                        }
                      >
                        {isFetchingCustomerDetails
                          ? 'Loading..'
                          : customerDetails && customerDetails[index]
                          ? customerDetails[index].name
                          : 'Not available'}
                      </s-col>
                    </s-row>
                    {currentCustomerDetailIndex === index ? (
                      <s-row class="customer-detail">
                        <s-col span="3">Access Start:</s-col>
                        <s-col span="3">
                          {info.accessStart.substring(0, 10)}
                        </s-col>
                      </s-row>
                    ) : null}
                  </div>
                );
              })
            : notAvailableResultItem}
        </s-container>
      </s-container>
    );
  }
}

export default ProductCard;
